(function($) {
    $(document).ready(function () {
        var burger = $('.hamburger');
        var nav = $('.primary-nav-container');

        if ($(window).width() > 1024) {
            nav.show();
            // showMenu();
        } else {
            hideMenu();
        }

        burger.click(function () {
            $(this).toggleClass('is-active');
            showOrHideMenu();
        });

        $(window).resize(function() {
            if ($(window).width() > 1024) {
                showMenu();
            } else {
                showOrHideMenu();
            }
        });

        function showOrHideMenu() {
            if (burger.hasClass('is-active')) {
                showMenu();
            } else {
                hideMenu();
            }
        }

        function showMenu() {
            nav.slideDown();
        }

        function hideMenu() {
            nav.slideUp();
        }
    });
})(jQuery, this);